import { useStaticQuery, graphql } from "gatsby";

const Image = () => {
  const data = useStaticQuery(graphql`
    fragment ImageStaffPhotos on File {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    query {
      elle: file(relativePath: { eq: "staff-photos/Ellie.jpeg" }) {
        ...ImageStaffPhotos
      }
      emma: file(relativePath: { eq: "staff-photos/Emma.jpeg" }) {
        ...ImageStaffPhotos
      }
      emilyW: file(relativePath: { eq: "staff-photos/emily-w.jpg" }) {
        ...ImageStaffPhotos
      }

      hughie: file(relativePath: { eq: "staff-photos/hughie.jpg" }) {
        ...ImageStaffPhotos
      }
      janine: file(relativePath: { eq: "staff-photos/janine.jpg" }) {
        ...ImageStaffPhotos
      }
      jemma: file(relativePath: { eq: "staff-photos/Jemma.jpeg" }) {
        ...ImageStaffPhotos
      }
      jesse: file(relativePath: { eq: "staff-photos/jesse.jpg" }) {
        ...ImageStaffPhotos
      }
      megan: file(relativePath: { eq: "staff-photos/megan.jpg" }) {
        ...ImageStaffPhotos
      }
      rachael: file(relativePath: { eq: "staff-photos/rachael.jpg" }) {
        ...ImageStaffPhotos
      }
      stacey: file(relativePath: { eq: "staff-photos/stacey.jpg" }) {
        ...ImageStaffPhotos
      }
      tayla: file(relativePath: { eq: "staff-photos/tayla.jpg" }) {
        ...ImageStaffPhotos
      }
      will: file(relativePath: { eq: "staff-photos/will.jpg" }) {
        ...ImageStaffPhotos
      }
    }
  `);

  return {
    elle: data.elle.childImageSharp.fluid,
    emma: data.emma.childImageSharp.fluid,
    emilyW: data.emilyW.childImageSharp.fluid,
    hughie: data.hughie.childImageSharp.fluid,
    janine: data.janine.childImageSharp.fluid,
    jemma: data.jemma.childImageSharp.fluid,
    jesse: data.jesse.childImageSharp.fluid,
    megan: data.megan.childImageSharp.fluid,
    rachael: data.rachael.childImageSharp.fluid,
    stacey: data.stacey.childImageSharp.fluid,
    tayla: data.tayla.childImageSharp.fluid,
    will: data.will.childImageSharp.fluid,
  };
};
export default Image;
